// extracted by mini-css-extract-plugin
export var fullWidthButton = "_e0-0";